import { apiProxyRequest } from "Api/apiProxyRequest";

import type {
  Activity,
  GetEnvironmentActivitiesRequestProps
} from "Api/activity/types";

export const getEnvironmentActivitiesRequest = ({
  projectId,
  encodedEnvId,
  filters,
  state,
  startsAt,
  cron,
  count
}: GetEnvironmentActivitiesRequestProps) =>
  apiProxyRequest<Activity[]>(
    `/projects/${projectId}/environments/${encodedEnvId}/activities`,
    "GET",
    { type: filters, state, starts_at: startsAt?.toISOString(), cron, count }
  );
